import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';

import { takeUntil } from 'rxjs/operators';
import { forkJoin, Observable, of } from 'rxjs';

import { SharedDataService, VerzekeringkiezerService, } from '@services/public_api';
import { SchademeldenState, CurrentvraagEventargs } from '@models/vragenboom';
import { Vragenboom, Vraag } from '@models/claims';
import { WindowService, DataService, MetenMapper, WindowSize, Devicetype, BaseOlsControlDirective, Proces } from '@components/public_api';
import { AnalyticsService, ApplicationInsightsService } from '@crosscutting/public_api';
import { SharedData } from '@models/shareddata';

@Component({
  selector: 'app-verzekeringkiezer',
  templateUrl: './verzekeringkiezer.component.html',
  styleUrls: ['./verzekeringkiezer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VerzekeringkiezerComponent extends BaseOlsControlDirective implements OnInit {
  vragenboom: Vragenboom;
  teksten: SharedData[];
  currentVraag: Vraag;
  isMobileView: boolean;
  status: SchademeldenState = SchademeldenState.Verzekeringkiezer;
  header: string;
  enableSubmitButton: boolean;
  pageviewId = 'ipoview-pa-schadecoach-kiezer';

  constructor(
    private _verzekeringkiezerService: VerzekeringkiezerService,
    private _windowService: WindowService,
    private _dataService: DataService,
    private _analyticsService: AnalyticsService,
    private _applicationInsightsService: ApplicationInsightsService,
    private _sharedDataService: SharedDataService,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit() {
    this._dataService.saveProces(Proces.SchadeCoach);
    this.enableSubmitButton = true;
    this.renderer.removeClass(document.body, 'ols-modal-open-loader');
    this.renderer.removeClass(document.body.parentElement, 'ols-modal-open-loader');
    this.header = '';
    this._dataService.saveMeetGegevensStatus(this.status);

    this.vragenboomBepalen();

    this._windowService.windowSizes$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: WindowSize) => {
        this.isMobileView = this._windowService.deviceType() <= Devicetype.TabletPortrait;
      });
  }

  vragenboomBepalen() {
    this.enableSubmitButton = false;
    this.renderer.addClass(document.body, 'ols-modal-open-loader');
    this.renderer.addClass(document.body.parentElement, 'ols-modal-open-loader');

    forkJoin([
      this.ophalenKiezer(),
      this.ophalenTeksten()
    ]).pipe(takeUntil(this.unsubscribe$))
    .subscribe(([vb, tk]: [Vragenboom, SharedData[]]) => {
      this.vragenboom = vb;
      this.teksten = tk;
      this.enableSubmitButton = true;
      this.renderer.removeClass(document.body, 'ols-modal-open-loader');
      this.renderer.removeClass(document.body.parentElement, 'ols-modal-open-loader');
    });
  }

  ophalenKiezer(): Observable<Vragenboom> {
    if (this.vragenboom == null) {
      return this._verzekeringkiezerService.getVerzekeringkiezer();
    }
    return of(this.vragenboom)
  }

  ophalenTeksten(): Observable<SharedData[]> {
    return this._sharedDataService.getTeksten();
  }

  geefTekst(name: string): string {
    return this.teksten ? this.teksten.find(t => t.Name === name)?.Phrase : '';
  }

  pageView(vraag: Vraag, reeks: Vraag[]) {
    const path = '/' + MetenMapper.geefVolgnr(vraag, reeks) + '-' + MetenMapper.formatGATitelMetToevoeging(vraag.titel, vraag.titel_toevoeging);
    if (!vraag.startvraag) {
      this.pageviewId = '';
    }
    this._analyticsService.googleEmitPageview(path);
    this._analyticsService.celebrusReinit();
    this._applicationInsightsService.logPageView(null, '/kiezer' + path);
  }

  currentVraagChanged(args: CurrentvraagEventargs) {
    setTimeout(() => {
      this.currentVraag = args.currentVraag;
      this.header = this.currentVraag.titel;
      this.pageView(args.currentVraag, args.vragenReeks);
    });
  }
}
